import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquery-page-configurator',
	templateUrl:'./JQueryPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./JQueryPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQueryPageConfiguratorPluginCompPage
{
	mdContent_1036 = `\`\`\`java
import com.jwebmp.plugins.jquery.JQueryPageConfigurator;
\`\`\``;
	mdContent_1037 = `\`\`\`java
JQueryPageConfigurator()
\`\`\``;
	mdContent_1038 = `\`\`\`java
// module-info.java
module com.myapp {
    requires com.jwebmp.plugins.jquery;
}
// JQueryPageConfigurator auto-registers:
// jquery-4.0.0.min.js and jquery-migrate-4.0.2.min.js
// as global scripts in angular.json
\`\`\``;
}
